// @flow

import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import { getClassName } from "ui-kit/utils/component";
//import { Page } from "components";
import "./Home.scss";


export const ccn = getClassName("Home");

type StateProps = {
  authorized: boolean
};

class Home extends Component {

  render() {
    return (
      <div className={ccn()}>

      </div>
    );
  }
}

const mapStateToProps = (state): StateProps => ({
});


export default withRouter(connect(mapStateToProps)(Home));



// WEBPACK FOOTER //
// ./src/containers/home/Home.js